module.exports = __webpack_public_path__ + "img/sale_bg.7d979107.jpg";